<template>
  <form id="form-relatorio-consumo-api">
    <h3 class="font-semibold">Relatório de Consumo API</h3>
    <small class="text-xs"
      >Defina um período para obter o relatório do consumo de créditos da
      API.</small
    >

    <div class="row">
      <div class="col-md-6">
        <div class="form-box -full -left">
          <div class="field-box">
            <AppDropdown
              ref="dateDropdown"
              :target="{ attrs: { type: 'button' } }"
              :theme="{ target: ['border', 'w-full', '!justify-start'] }"
            >
              <template #target>
                {{ formatDates(dateOne, dateTwo) || "Selecionar datas" }}
              </template>
              <template #popover>
                <AppCalendar
                  style="width: 100% !important"
                  :use-controls="true"
                  :initialDate="minDate"
                  :finalDate="endDate"
                  :positive-control="{text: 'Selecionar'}"
                  @start-date="addStartDate"
                  @end-date="addEndDate"
                  @date-confirmation="closeDropdown"
                />
              </template>
            </AppDropdown>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-box -right -full">
          <Btn
            class="info upper md"
            :loading="$wait.is('dowloading')"
            :disabled="!dateOne || !dateTwo || $wait.is('dowloading')"
            @click="downloadReport"
            >Exportar</Btn
          >
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import format from "date-fns/format";
import pt from "date-fns/locale/pt";
import AppCalendar from "../../_painel_admin/components/global/AppCalendar/index.vue"; // Todo: mover para projeto npm
import parseISO from "date-fns/esm/fp/parseISO/index.js";
export default {
  name: "RelatorioConsumoApi",
  props: ["action", "dataLimite"],
  components: { AppCalendar },
  data() {
    return {
      showCalendar: false,
      enabled: false,
      searchWordsNumber: 0,
      dateModal: false,
      dateFormat: "dd MMM",
      dateOne: "",
      dateTwo: "",
      filtersList: [],
      tempChoices: {},
      choices: {},
      actived: null,
      term: "",
      searchBoxFiltersOptions: [],
      showingOptions: false,
    };
  },
  computed: {
    minDate() {
      if (!this.dateOne) {
        return null;
      }

      let dataMaxima = new Date(
        this.formatDate(new Date(this.dateOne), "yyyy-MM-dd")
      );
      dataMaxima.setDate(dataMaxima.getDate() - 60);

      return dataMaxima;
    },
    endDate() {
      if (!this.dateOne) return new Date(this.dataLimite);

      let dataMaxima = new Date(
        this.formatDate(new Date(this.dateOne), "yyyy-MM-dd")
      );
      dataMaxima.setDate(dataMaxima.getDate() + 60);
      if (dataMaxima > new Date(this.dataLimite))
        return new Date(this.dataLimite);

      return new Date(dataMaxima);
    },
  },
  methods: {
    closeDropdown() {
      this.$refs.dateDropdown.hide();
    },
    addStartDate($event) {
      this.dateOne = ($event && $event.sql) || "";
    },
    addEndDate($event) {
      this.dateTwo = ($event && $event.sql) || "";
    },
    showMessage(type, message) {
      let options = {
        position: "bottom-center",
        duration: 3000,
        className: ["c-toast", "u--no-print"],
        containerClass: ["c-toast_container", "u--no-print"],
        closeOnSwipe: false,
      };

      if (type == "info") {
        Vue.toasted.info(message, {
          ...options,
          className: [...options.className, "v--primary"],
        });
      } else if (type == "error") {
        Vue.toasted.error(message, {
          ...options,
          className: [...options.className, "v--negative"],
        });
      }
    },
    downloadReport() {
      this.showCalendar = false;
      this.$wait.start("dowloading");
      if (!this.dateOne || !this.dateTwo) {
        this.$wait.end("dowloading");
        this.showMessage("error", "Você precisa escolher duas datas.");
        return;
      }

      let url =
        this.action + "?data_de=" + this.dateOne + "&data_ate=" + this.dateTwo;

      fetch(url, {
        method: "GET",
      })
        .then((response) => {
          if (response.ok) {
            let metadata = response.headers.get("content-disposition");

            // Caso o retorno seja um objeto vazio.
            if (!metadata) {
              this.showMessage(
                "info",
                "Não há requisições para o período selecionado."
              );
              return;
            }

            let filename =
              "relatorio-api-" + this.dateOne + "-" + this.dateTwo + ".xlsx";

            response.blob().then((blob) => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              a.remove();
            });
          } else {
            throw new Exception();
          }
        })
        .catch(() => {
          this.showMessage("error", "Ocorreu um erro ao gerar o relatório.");
        })
        .finally(() => {
          this.$wait.end("dowloading");
        });
    },
    formatDate(date, mask = "yyyyMMdd") {
      return format(date, mask);
    },
    closeDateModal() {
      this.dateModal = false;
    },
    openDateModal() {
      this.dateModal = true;
    },
    clearDates() {
      this.dateOne = "";
      this.dateTwo = "";
      this.dateModal = false;
    },
    formatDates(dateOne, dateTwo) {
      this.dateModal = false;
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(parseISO(dateOne), this.dateFormat, {
          locale: pt,
        });
      }
      if (dateTwo) {
        formattedDates +=
          " - " + format(parseISO(dateTwo), this.dateFormat, { locale: pt });
      }

      return formattedDates;
    },
  },
};
</script>

<style lang="stylus" scoped>
.date-picker-periodo
  left 0 !important
</style>

<style>
.c-field-base-custom div {
  margin-top: 0 !important;
}
</style>
